import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { SubmissionError, change, untouch } from 'redux-form'
import { saveAffidavit, getNextStep, submitForm, stopSubmitForm } from '../actions/users';
import { getErrorsApiToReduxForm } from '../utils/utils.js';
import Affidavit from '../components/Affidavit.js';

const mapStateToProps = (state) => {

    return {
        isLoading: state.users.isLoading
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        deleteReduxFormField(fieldName){
            dispatch(change('Affidavit', fieldName, null));
            dispatch(untouch('Affidavit', fieldName));
        },
        sentAffidavit(values){
            dispatch(submitForm());
            return dispatch(saveAffidavit(values)).then((result) => {

                    if (typeof(result.payload.response) !== 'undefined') {
                        if(result.payload.response.status === 400) {
                            dispatch(stopSubmitForm());
                            throw new SubmissionError({...getErrorsApiToReduxForm(result.payload.response.data), _error: 'Revisá los campos indicados.'});
                        }
                    } else {
                        dispatch(getNextStep()).then((result) => {
                            if (typeof(result.payload.data.endpoint) !== "undefined") {
                                sessionStorage.setItem('endpoint',result.payload.data.endpoint);
                                dispatch(stopSubmitForm());
                                browserHistory.push(result.payload.data.endpoint)
                            }
                        });
                    }
                });
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Affidavit);



/** WEBPACK FOOTER **
 ** ./src/containers/AffidavitContainer.js
 **/